import { Link } from 'react-router-dom'
import artistData from '../../data/artist.json'
import Section from '../common/Section'
import Button from '../common/Button'

export default function Hero() {
  return (
    <Section background="white" padding="large">
      <div className="max-w-5xl mx-auto text-center">
        {/* Artist Name */}
        <h1 className="text-5xl md:text-7xl font-serif text-primary mb-6 animate-fade-in">
          {artistData.name}
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-neutral-600 mb-8">
          {artistData.art}
        </p>

        {/* Signature Quote */}
        {true && (
          <div className="max-w-3xl mx-auto my-12 p-8 bg-neutral-50 rounded-lg border-l-4 border-primary">
            <blockquote className="text-lg md:text-xl font-serif italic text-neutral-800">
              &ldquo;{artistData.signature}&rdquo;
            </blockquote>
            <cite className="block mt-4 text-sm text-neutral-600 not-italic">
              - {artistData.name}
            </cite>
          </div>
        )}

        {/* Event Banner */}
        {false && (
          <Link to="/ausstellungen" className="block relative max-w-3xl mx-auto my-12 rounded-lg overflow-hidden shadow-xl cursor-pointer group">
            {/* Background Image */}
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: "url('/images/event/medium/spectrum-000.jpg')" }}
            />
            {/* Dark overlay for readability */}
            <div className="absolute inset-0 bg-black/55" />

            {/* Content */}
            <div className="relative z-10 px-8 py-10 text-white">
              {/* Label */}
              <p className="text-xs uppercase tracking-widest text-white/70 font-semibold mb-4">
                Veranstaltung
              </p>

              {/* Title */}
              <h2 className="text-2xl md:text-3xl font-serif font-semibold mb-5 leading-snug">
                Ausstellung <span className="italic">&bdquo;Spektrum&ldquo;</span>
              </h2>

              {/* Divider */}
              <div className="w-10 h-px bg-primary mb-5" />

              {/* Event Details */}
              <ul className="space-y-2 text-sm md:text-base text-white/90">
                <li className="flex items-center gap-2">
                  <span className="text-primary">✦</span>
                  <span>
                    <strong className="font-semibold">Ausstellung:</strong> bis 15. Juni 2026
                  </span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-primary">✦</span>
                  <span>
                    <strong className="font-semibold">Ort:</strong> <a href="https://cafe-panorama.com/" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-primary transition-colors duration-200">Café-Panorama</a> in Denzlingen
                  </span>
                </li>
              </ul>
            </div>
          </Link>
        )}

        {/* Call to Action */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
          <Link to="/werke">
            <Button variant="outline" size="large">
              Werke ansehen
            </Button>
          </Link>
          <Link to="/ausstellungen">
            <Button variant="outline" size="large">
              Ausstellungen ansehen
            </Button>
          </Link>
          <Link to="/vita">
            <Button variant="outline" size="large">
              Über die Künstlerin
            </Button>
          </Link>
        </div>

        {/* Brief Introduction */}
        <div className="mt-16 max-w-2xl mx-auto">
          <p className="text-base md:text-lg text-neutral-700 leading-relaxed">
            {artistData.bio.short}
          </p>
        </div>
      </div>
    </Section>
  )
}
